"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _format = require("./format");

exports.default = function (value, dateFormat, opts) {
    if (!value) {
        return null;
    }

    dateFormat || (dateFormat = _format.DEFAULT_DATE_FORMAT);
    opts || (opts = {});

    if (value.type === "range") {
        if (value.start && value.end) {
            var start = (0, _format.format)(value.start, dateFormat, opts);
            var end = (0, _format.format)(value.end, dateFormat, opts);
            return start + " - " + end;
        }
    }

    return null;
};
//# sourceMappingURL=DateFormatRange.js.map